<div class="animated fadeIn">
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div>
            <div class="mt-4">
              <p-table
                dataKey="_id"
                responsiveLayout="stack"
                [value]="items()"
                [customSort]="true"
                (sortFunction)="getSortedPaginatedItems($event)"
                [(selection)]="checkedItems"
              >
                <ng-template pTemplate="caption">
                  <div class="grid">
                    <div class="sm:col-6 col-12">
                      <span>
                        <button
                          pButton
                          icon="pi pi-plus"
                          label="Create New Item"
                          [routerLink]="isSelectDialog() ? null : ['../add-item']"
                          (click)="isSelectDialog() ? openAddItemDialog() : null"
                          class="p-button-outlined mb-2 mr-2"
                        ></button>
                        <!-- [appPermission]="[
                                                        ORGANIZATION_PERMISSION_TYPE.ADMIN,
                                                        ORGANIZATION_PERMISSION_TYPE.OWNER,
                                                        ORGANIZATION_PERMISSION_TYPE.INVENTORY_ADMIN,
                                                        ORGANIZATION_PERMISSION_TYPE.ADMIN,
                                                        ORGANIZATION_PERMISSION_TYPE.INVENTORY_CREATOR_ONLY,
                                                        ORGANIZATION_PERMISSION_TYPE.INVENTORY_READ_WRITE_ONLY
                                                    ]" -->
                        <button
                          *ngIf="!isSelectDialog()"
                          pButton
                          icon="pi pi-file-excel"
                          label="Upload"
                          (click)="openFileUploadModal()"
                          class="p-button-outlined mb-2 mr-2"
                        ></button>

                        <button
                          *ngIf="!isSelectDialog() && items.length > 0"
                          pButton
                          icon="pi pi-file-excel"
                          [label]="exportingItems ? 'Exporting...' : 'Export'"
                          class="p-button-outlined mb-2 mr-2"
                          (click)="getAllItems()"
                          [disabled]="exportingItems"
                        ></button>
                      </span>
                      <button
                        *ngIf="isSelectDialog()"
                        pButton
                        icon="pi pi-plus"
                        label="Add Selected Items"
                        (click)="addToCategory()"
                        class="mb-2 mr-2"
                      ></button>
                      <span style="position: relative">
                        <p-menu appendTo="body" #menu [model]="filterItems" [popup]="true">
                          <ng-template pTemplate="item" let-item>
                            <a pRipple class="flex align-items-center p-menuitem-link">
                              <i *ngIf="item.value == searchText" class="pi pi-check-circle ml-2" style="color: green"></i>
                              <span class="ml-2">{{ item.label }}</span>
                            </a>
                          </ng-template>
                        </p-menu>

                        <button
                          *ngIf="!isSelectDialog()"
                          pButton
                          type="button"
                          (click)="menu.toggle($event)"
                          icon="pi pi-filter"
                          label="Filter"
                          class="p-button-outlined mb-2 mr-2"
                        ></button>
                      </span>
                      <button
                        *ngIf="!isSelectDialog()"
                        pButton
                        label="Clear"
                        class="p-button-outlined mb-2"
                        icon="pi pi-filter-slash"
                        (click)="clearSearch()"
                        [disabled]="!searchText"
                      ></button>
                    </div>

                    <div class="sm:col-6 col-12 text-right">
                      <span class="p-input-icon-left mb-2 sm:w-auto w-full">
                        <i class="pi pi-search"></i>
                        <input
                          pInputText
                          class="p-inputtext p-component p-element w-full"
                          #search
                          type="text"
                          placeholder="Search... "
                          [(ngModel)]="searchText"
                          (ngModelChange)="onSearchTermChange($event)"
                          (keyup.enter)="searchOnEnter(search.value)"
                        />
                      </span>

                      <button pButton class="p-button-outlined mb-2" icon="pi pi-search" (click)="getSearchResults()" *ngIf="searchText"></button>
                    </div>
                  </div>
                  <div class="col-12" *ngIf="!isSelectDialog()">
                    <div class="flex sm:flex-row flex-column justify-content-center">
                      <div class="col-12 md:col-3">
                        <div
                          class="card widget-overview-box widget-overview-box-2 cursor-pointer surface-border border-1 hover:shadow-2"
                          [ngClass]="{
                            'shadow-2': searchText === 'INSTOCK'
                          }"
                          (click)="(searchText = 'INSTOCK') && getSearchResults()"
                        >
                          <span class="overview-title">ITEMS IN STOCK</span>
                          <div class="flex justify-content-between">
                            <div class="overview-detail flex justify-content-between">
                              <div class="overview-text text-4xl">
                                {{ stockMetrics.itemsInStock }}
                              </div>
                            </div>
                            <i class="pi pi-check-circle" style="font-size: 3rem; color: #24de9b"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 md:col-3">
                        <div
                          class="card widget-overview-box widget-overview-box-3 cursor-pointer surface-border border-1 hover:shadow-2"
                          [ngClass]="{
                            'shadow-2': searchText === 'LOWSTOCK'
                          }"
                          (click)="(searchText = 'LOWSTOCK') && getSearchResults()"
                        >
                          <span class="overview-title"> ITEMS LOW ON STOCK </span>
                          <div class="flex justify-content-between">
                            <div class="overview-detail flex justify-content-between">
                              <div class="overview-text text-4xl">
                                {{ stockMetrics.itemsOnLowStock }}
                              </div>
                            </div>
                            <i class="pi pi-clock text-yellow-500" style="font-size: 3rem"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 md:col-3">
                        <div
                          class="card widget-overview-box widget-overview-box-3 cursor-pointer surface-border border-1 hover:shadow-2"
                          [ngClass]="{
                            'shadow-2': searchText === 'OUTOFSTOCK'
                          }"
                          (click)="(searchText = 'OUTOFSTOCK') && getSearchResults()"
                        >
                          <span class="overview-title"> ITEMS OUT OF STOCK </span>
                          <div class="flex justify-content-between">
                            <div class="overview-detail flex justify-content-between">
                              <div class="overview-text text-4xl">
                                {{ stockMetrics.outOfStockItems }}
                              </div>
                            </div>
                            <i class="pi pi-times-circle" style="font-size: 3rem; color: #ff6565"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>

                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 4rem" *ngIf="isSelectDialog()">
                      <p-tableHeaderCheckbox />
                    </th>

                    <th *ngFor="let column of tableColumns" [pSortableColumn]="column.fieldName">
                      {{ column?.displayName }}
                      <p-sortIcon [field]="column.fieldName"></p-sortIcon>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                  <tr class="table-row-clickable p-selectable-row">
                    <td *ngIf="isSelectDialog()">
                      <p-tableCheckbox [value]="item" />
                    </td>
                    <td
                      [ngClass]="{
                        name: !isSelectDialog()
                      }"
                      [routerLink]="!isSelectDialog() ? ['/app/items/details/', item?._id] : null"
                    >
                      {{ item?.name }}
                    </td>
                    <td>
                      {{
                        item?.itemType === 'INVENTORYITEM'
                          ? 'Goods'
                          : item?.itemType === 'SERVICEITEM'
                            ? 'Service'
                            : item?.itemType === 'BOOKABLERESOURCE'
                              ? 'Bookable'
                              : '--'
                      }}
                    </td>

                    <td class="px-4 text-center">
                      @if (item?.trackInventory) {
                        <span>
                          {{ item.quantity | number: '1.0-0' : 'en' }}
                          &nbsp; items
                        </span>
                      } @else {
                        <span> No inventory tracking </span>
                      }
                    </td>

                    <td>
                      <span *ngIf="(!item?.trackInventory && item?.itemType === 'INVENTORYITEM') || item?.itemType === 'SERVICEITEM'">
                        On Request
                      </span>

                      <span *ngIf="item?.itemType === 'BOOKABLERESOURCE'">Available</span>
                      <span
                        *ngIf="item?.trackInventory && item?.itemType === 'INVENTORYITEM'"
                        [class]="
                          'product-badge status-' +
                          (item.inStock === 'INSTOCK' ? 'instock' : item.inStock === 'OUTOFSTOCK' ? 'outofstock' : 'lowstock')
                        "
                      >
                        {{ item.inStock === 'INSTOCK' ? 'INSTOCK' : item.inStock === 'OUTOFSTOCK' ? 'OUTOFSTOCK' : 'LOWSTOCK' }}
                      </span>
                    </td>
                    <!-- <td>
                                            {{
                                                item?.trackInventory
                                                    ? item?.quantity
                                                    : "No inventory tracking"
                                            }}
                                        </td> -->
                    <td>
                      {{ (item?.cost | currency: utilService.getCurrentCurrency()) || '--' }}
                    </td>
                    <td>
                      {{ item?.price | currency: utilService.getCurrentCurrency() }}
                    </td>
                    <td *ngIf="!isSelectDialog()">
                      <p-splitButton
                        label="Details"
                        icon="pi pi-eye"
                        [model]="item.menuItems"
                        (onClick)="router.navigate(['/app/items/details/' + item?._id])"
                      ></p-splitButton>
                      <!-- <p-splitButton
                                                *ngIf="
                                                    item?.trackInventory
                                                "
                                                label="Restock"
                                                icon="pi pi-plus"
                                                [model]="item.menuItems"
                                                (onClick)="
                                                    router.navigate([
                                                        '/app/items/details/' +
                                                            item?._id +
                                                            '/restock'
                                                    ])
                                                "
                                            ></p-splitButton> -->
                    </td>
                  </tr>
                </ng-template>
              </p-table>

              <div class="grid m-0">
                <div class="col-sm">
                  <p-paginator
                    #paginator
                    [rows]="rows"
                    [totalRecords]="allItemsCount"
                    (onPageChange)="paginate($event)"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                  ></p-paginator>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header=" Choose Quantity Update Option for Uploaded Items" [(visible)]="itemUploadQuantityOptionDialog" [style]="{ width: '75vw' }">
  <!-- <div class="card">
        <p-table
            [value]="excelUploadFields"
            [tableStyle]="{ 'min-width': '50rem' }"
            class="p-6"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>System Field</th>
                    <th>Your Field</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-field>
                <tr>
                    <td>{{ field.systemField }}</td>
                    <td>
                        <p-dropdown
                            [options]="itemToUploadColTitles"
                            [(ngModel)]="field.userProvidedField"
                            placeholder="Select a matching field"
                        />
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div> -->

  <div class="flex flex-column lg:flex-row gap-3 justify-content-between lg:align-items-center py-5">
    <div class="flex flex-column gap-2">
      <p class="mb-0 mt-0 text-base text-600">
        Select whether to update item quantities from the uploaded file or maintain existing quantities. Note that these are only inventory items you
        want to track.
      </p>
    </div>
    <div class="flex align-items-center gap-2">
      <button pButton icon="pi pi-upload" label="Save & Upload" (click)="addBulkItems()"></button>
    </div>
  </div>
  <p-table [value]="itemsToUploadWithTrackInventory" responsiveLayout="stack">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">Name <p-sortIcon field="name"></p-sortIcon></th>
        <th pSortableColumn="type">Type<p-sortIcon field="type"></p-sortIcon></th>
        <th pSortableColumn="quantity">Quantity<p-sortIcon field="quantity"></p-sortIcon></th>
        <th pSortableColumn="cost">Cost<p-sortIcon field="cost"></p-sortIcon></th>
        <th pSortableColumn="price">Price<p-sortIcon field="price"></p-sortIcon></th>
        <th>
          <p-checkbox [(ngModel)]="selectAllItemsToUpload" [binary]="true" (onChange)="selectAllItemsToUploadFunc()"></p-checkbox>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr class="table-row-clickable p-selectable-row">
        <td>
          {{ item?.name }}
        </td>
        <td>
          {{ item?.itemType === 'INVENTORYITEM' ? 'Goods' : 'Service' }}
        </td>
        <td>
          <span *ngIf="!item?.trackInventory && item?.itemType === 'INVENTORYITEM'"> On Request </span>
          <span *ngIf="item?.itemType === 'SERVICEITEM'"> Service </span>
          <span *ngIf="item?.trackInventory && item?.itemType === 'INVENTORYITEM'">
            {{ item.quantity }}
          </span>
        </td>
        <td>
          {{ (item?.cost | currency: utilService.getCurrentCurrency()) || '--' }}
        </td>
        <td>
          {{ item?.price | currency: utilService.getCurrentCurrency() }}
        </td>
        <td>
          <p-checkbox
            [(ngModel)]="item.updateQuantity"
            [binary]="true"
            [inputId]="item._id"
            [name]="item._id"
            [value]="item.updateQuantity"
          ></p-checkbox>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>
